import { API_PATH } from "../../constants";
import { axiosRequest } from "../api";

export const ProviderTaminService = {
  getTaminAuth(params: any) {
    return axiosRequest("GET", API_PATH.PROVIDER_TAMIN.AUTH(params));
  },
  verifyTaminAuth(params: any) {
    return axiosRequest("GET", API_PATH.PROVIDER_TAMIN.AUTH_VERIFY(params));
  },
  getTaminAuthStatus() {
    return axiosRequest("GET", API_PATH.PROVIDER_TAMIN.AUTH_STATUS());
  },
  getTaminReferralCount(params: any) {
    return axiosRequest("GET", API_PATH.PROVIDER_TAMIN.REFERRAL_COUNT(params));
  },
  getTaminReferralByTrackingCode(patientId: number, trackingCode: number) {
    return axiosRequest(
      "GET",
      API_PATH.PROVIDER_TAMIN.GET_REFERRAL_BY_TRACKING_CODE(
        patientId,
        trackingCode
      )
    );
  },
};
